// Highlight IFC objects in the local viewer by uncompressed GUID (replaces Trimble convertToObjectRuntimeIds).
import _ from "lodash";

export function selectModelGUIDS(uncompressedGuids, _modelId, modelIndex) {
  if (_.isEmpty(uncompressedGuids) || !window.ifc_viewer?.selectByGuids) return;
  const mode = modelIndex == 0 || modelIndex == null ? "set" : "add";
  window.ifc_viewer.selectByGuids(uncompressedGuids, mode);
}
